module.exports = __webpack_public_path__ + "img/zerweima.614e3097.png";